import VCSearchBusinesses from "./VCSearchBusinesses";

export default VCSearchBusinesses;
